import Ajax from '../../../../common/js/Ajax.js';
import Form from '../../../../common/js/form/Form.js';
import MessageUtils from '../../../../common/js/MessageUtils.js';
import TippspielWidget from '../TippspielWidget.js';
import UrlParser from '../../../../common/js/UrlParser.js';

export default class FinishPasswordResetWidget extends TippspielWidget {

	constructor($widget) {
		super($widget);
		this.token = UrlParser.getParams()['token'];
	}
	
	onLoginReady() {
		Form.onSubmit(this.$widget, action => {
			var $password1 = action.findField('password');
			var $password2 = action.findField('password2');
			if ($password1.val() !== $password2.val()) {
				Form.showFieldError({
					$field: $password2,
					short: 'Passwörter stimmen nicht überein.',
					long: 'Die Passwörter stimmen nicht überein.'
				});
				action.error();
				return;
			}

			Ajax.rpc('/finish-password-reset', {
				token: this.token,
				password: $password1.val()
			}, success => {
				if (success) {
					action.$button.remove();
					action.ok('Perfekt. Dein Passwort wurde neu gesetzt. Jetzt kannst du dich [wieder einloggen|/].');
				} else {
					action.error('Das hat leider nicht geklappt. Möchtest du es [nochmal versuchen|/passwort-vergessen]?');
				}
			}, error => {
				MessageUtils.error(this.$widget, TippspielWidget.getFailedMessage(), error);
			});
		});
	}

}
